// extracted by mini-css-extract-plugin
export default {"root":"Navbar_root__sQAYN","menuWrapper":"Navbar_menuWrapper__6Srj-","titleWrapper":"Navbar_titleWrapper__IaaWj","accountWrapper":"Navbar_accountWrapper__htXjD"};